
class Form {
	fields = {}
	addField(field) {
		this.fields[field.name] = field
	}
}

export default Form